import useLocalStorage from './useLocalStorage';

export default () => {
    const [paymentSuccessful, setPaymentSuccessful] = useLocalStorage('paymentSuccessful', {});

    return { paymentSuccessful, setPaymentSuccessful };
};
